import { render, staticRenderFns } from "./BasicsSingle.vue?vue&type=template&id=2b460942&"
import script from "./BasicsSingle.vue?vue&type=script&lang=js&"
export * from "./BasicsSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports